export function getIntegerValue(value) {
  const parsedValue = Number.parseInt(value, 10);
  return Number.isNaN(parsedValue) ? undefined : parsedValue;
}

export function getTextValue(value) {
  return String(value).trim() === '' ? undefined : value;
}
